import { getCurrentRoute } from '@/services/route';

import { getCompanySubdomain } from '../helpers';
import {
  getLocalStorageOversightToken,
  getLocalStorageToken,
} from '../helpers/localStorage';

const API_PORT = process.env.REACT_APP_API_PORT || '';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
const STRING_REPLACE = '{{subdomain}}';

export const handleUrl = (): string => {
  if (API_BASE_URL) {
    return API_BASE_URL;
  }

  const companySubdomain = getCompanySubdomain();
  const dynamicUrl = `https://${STRING_REPLACE}.com.br:${API_PORT}`;

  if (companySubdomain) {
    return dynamicUrl.replace(STRING_REPLACE, companySubdomain);
  }

  return dynamicUrl.replace(STRING_REPLACE, 'realprice-st.protoai');
};

export const buildBaseHeaders = (): Headers => {
  const myHeaders = new Headers();
  const route = getCurrentRoute();
  const token = getLocalStorageToken();

  const normalizeRoute = (route?: string): string =>
    route?.trim() ? route : 'unknown';

  if (token) {
    myHeaders.append('Authorization', `Bearer ${token}`);
  }

  myHeaders.append('Event-Type', normalizeRoute(route));

  return myHeaders;
};

export const myHeadersWithTokenContentType = (): Headers => {
  const myHeaders = buildBaseHeaders();
  myHeaders.append('Content-Type', 'application/json');

  return myHeaders;
};

export const myHeadersWithToken = (): Headers => {
  return buildBaseHeaders();
};

export const myHeadersWithTokenOversight = (): Headers => {
  const myHeaders = new Headers();
  const oversightToken = getLocalStorageOversightToken();

  if (oversightToken) {
    myHeaders.append('Authorization', `Bearer ${oversightToken}`);
  }

  return myHeaders;
};
